var el = {
  "Add Upsell.com to your ": "Προσθέστε το Upsell.com στη ",
  "All time": "Όlo το χρόνο",
  "and select": "και επιλέξτε",
  "button": "κουμπί",
  "Cart drawer page": "Σελίδα Συρταριού Καλαθιού",
  "Cart page": "Σελίδα Καλαθιού",
  "Check status": "Έλεγχος κατάστασης",
  "Checkout page": "Σελίδα Ταμείου",
  "Click": "Κάντε κλικ",
  "Click on": "Κάντε κλικ",
  "Click the": "Κάντε κλικ στο",
  "Custom slot": "Προσαρμοσμένη Θέση",
  "Custom slots": "Προσαρμοσμένες Θέσεις",
  "Custom Slots": "Προσαρμοσμένες Θέσεις",
  "contact support.": "επικοινωνήστε με την υποστήριξη.",
  "from the right sidebar": "από τη δεξιά πλευρική γραμμή",
  "Go to your Cart drawer page": "Πηγαίνετε στη σελίδα Συρταριού Καλαθιού",
  "Go to your Cart page": "Πηγαίνετε στη σελίδα Καλαθιού",
  "Go to your Checkout page": "Πηγαίνετε στη σελίδα Ταμείου",
  "Go to your Order status page": "Πηγαίνετε στη σελίδα Κατάστασης Παραγγελίας",
  "Go to your Post purchase page": "Πηγαίνετε στη σελίδα Μετά την Αγορά",
  "Go to your Product page": "Πηγαίνετε στη σελίδα Προϊόντος",
  "Go to your Thank you page": "Πηγαίνετε στη σελίδα Ευχαριστώ",
  "items": "είδη",
  "in the left sidebar": "στην αριστερή πλευρική γραμμή",
  "Last 12 months": "Τελευταίοι 12 μήνες",
  "Last 30 days": "Τελευταίες 30 ημέρες",
  "Last 365 days": "Τελευταίες 365 ημέρες",
  "Last 7 days": "Τελευταίες 7 ημέρες",
  "Last 90 days": "Τελευταίες 90 ημέρες",
  "Last month": "Περασμένος μήνας",
  "Last year": "Περασμένο έτος",
  "Make sure": "Βεβαιωθείτε ότι",
  "Need assistance? Contact our support team for help.": "Χρειάζεστε βοήθεια; Επικοινωνήστε με την ομάδα υποστήριξής μας.",
  "Order status page": "Σελίδα Κατάστασης Παραγγελίας",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "Η εφαρμογή μας υποβάλλεται αυτή τη στιγμή σε βελτιώσεις για να ενισχύσουμε την εμπειρία σας.",
  "Post purchase page": "Σελίδα Μετά την Αγορά",
  "Product page": "Σελίδα Προϊόντος",
  "Save": "Αποθήκευση",
  "Scroll to the bottom and select": "Κυλήστε προς τα κάτω και επιλέξτε",
  "Select": "Επιλέξτε",
  "Success. Please continue.": "Επιτυχία. Παρακαλώ συνεχίστε.",
  "Thank you page": "Σελίδα Ευχαριστώ",
  "The Upsell.com team.": "Η ομάδα του Upsell.com.",
  "The Upsell.com widget is not placed on ": "Το widget του Upsell.com δεν έχει τοποθετηθεί στη ",
  ". Please follow the steps above or ": ". Παρακαλώ ακολουθήστε τα παραπάνω βήματα ή ",
  "Today": "Σήμερα",
  "toggle is on": "ο διακόπτης είναι ενεργός",
  "Total": "Σύνολο",
  "under": "κάτω από",
  "We apologize for any inconvenience caused,": "Ζητούμε συγνώμη για την όποια ταλαιπωρία,",
  "We apologize for any inconvenience caused.": "Ζητούμε συγνώμη για την όποια ταλαιπωρία.",
  "We'll be done in a few minutes!": "Θα τελειώσουμε σε λίγα λεπτά!",
  "We're improving our services!": "Βελτιώνουμε τις υπηρεσίες μας!",
  "Widget already added": "Το widget έχει ήδη προστεθεί",
  "Yesterday": "Χθες",
  "You placed the widget on the ": "Τοποθετήσατε το widget στη ",
  ", but you didn't save it in Shopify editor. Please go back to ": ", αλλά δεν το αποθηκεύσατε στον επεξεργαστή Shopify. Παρακαλώ επιστρέψτε στη ",
  " and save the changes.": " και αποθηκεύστε τις αλλαγές."
};

export { el as default };
//# sourceMappingURL=el.json.js.map
